import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchParamsAsText',
})
export class SearchParamsAsTextPipe implements PipeTransform {
  transform(value: any, ..._args: any[]): any {
    if (!value) {
      return '';
    }

    return Object.values(value).filter((prop) => prop !== '' && prop !== undefined);
  }
}
